import { render, staticRenderFns } from "./are-both-parents-registered-select.vue?vue&type=template&id=39192468&scoped=true&"
import script from "./are-both-parents-registered-select.vue?vue&type=script&lang=js&"
export * from "./are-both-parents-registered-select.vue?vue&type=script&lang=js&"
import style0 from "./are-both-parents-registered-select.vue?vue&type=style&index=0&id=39192468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39192468",
  null
  
)

export default component.exports